/**
 * 브레드크럼(Breadcrumb) 네비게이션 컴포넌트
 * 사용자의 현재 위치를 표시하는 경로 내비게이션입니다.
 * 홈 > 메뉴 > 서브메뉴 형식으로 표시됩니다.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import iconHome from '../assets/icon_home.png';

/**
 * Location 컴포넌트
 * @param {Object} props
 * @param {string} props.menu - 현재 메인 메뉴명 (예: "센터소개", "돌봄서비스")
 * @param {string} props.submenu - 현재 서브메뉴명 (예: "인사말", "연혁") - 빈 문자열이면 표시 안 함
 * @param {string} props.link - 메인 메뉴 링크 경로
 *
 * @example
 * // 서브메뉴가 있는 경우
 * <Location menu="센터소개" submenu="인사말" link="/introduce/1" />
 * // 결과: 홈 > 센터소개 > 인사말
 *
 * @example
 * // 서브메뉴가 없는 경우
 * <Location menu="공지사항" submenu="" link="/notice" />
 * // 결과: 홈 > 공지사항
 */
function Location({ menu, submenu, link }) {
  // 경로 구분자
  const arrow = ' > ';

  return (
    <Container>
      <BreadcrumbText>
        {/* 홈 링크 */}
        <HomeLink to="/">
          <HiddenText>홈바로가기</HiddenText>
        </HomeLink>
        {arrow}

        {/* 서브메뉴가 있는 경우: 메뉴 > 서브메뉴 */}
        {submenu !== '' && (
          <>
            <MenuLink to={link}>{menu}</MenuLink>
            {arrow}
            <SubMenuText>{submenu}</SubMenuText>
          </>
        )}

        {/* 서브메뉴가 없는 경우: 메뉴만 표시 */}
        {submenu === '' && (
          <>
            <MenuLink to={link}>
              <MainMenuText>{menu}</MainMenuText>
            </MenuLink>
          </>
        )}
      </BreadcrumbText>
    </Container>
  );
}

export default Location;

/* Styled Components */

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  padding-bottom: 10px;
  /* 모바일 스타일 - 숨김 */
  @media (max-width: 767px) {
    display: none;
  }
`;

const BreadcrumbText = styled.p`
  font-family: 'nbg';
  font-size: 13px;
  margin: 0;
`;

const MenuLink = styled(Link)`
  font-size: 9pt;
  color: #8c8c8c;
  margin: 0 2px;
  padding: 0;
  font-size: 13px;
  font-family: 'koPubWorld DotumM';
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
    color: #252525;
  }
`;

const HomeLink = styled(Link)`
  width: 14px;
  height: 14px;
  background: url(${iconHome}) left 50% no-repeat;
  background-size: 14px 14px;
  display: inline-block;
  position: relative;
  top: 2px;
  margin: 0 2px;
`;

const HiddenText = styled.span`
  position: absolute;
  overflow: hidden;
  top: 0;
  visibility: hidden;
  width: 1px;
  height: 1px;
`;

const SubMenuText = styled.strong`
  color: #646464;
  font-weight: bold;
  font-size: 13px;
  font-family: 'koPubWorld DotumB';
`;

const MainMenuText = styled.strong`
  color: #646464;
  font-weight: bold;
  font-size: 13px;
  font-family: 'koPubWorld DotumB';
`;
